module.exports = __webpack_public_path__ + "static/media/onderweg_in_spanje.b1649aa8.jpg";